
import React, { useEffect } from 'react'
import { Navigate, Redirect, Route } from 'react-router-dom'
import { routeACL, SCOPE, paths } from '../config/router.config'
import { getData, clearSession, getOrderStatusInfo } from '../utils/commons'
import Login from '../pages/login/LoginController'
import ErrorPage from '../pages/ErrorPage'
import CustomMenu from '../components/CustomMenu'
import CustomContainer from '../components/CustomContainer'
import { Grid } from '@mui/material'
import theme from '../theme.css'
import LandingPageController from '../pages/landing-page/LandingPageController';
import CustomMain from '../components/CustomMain'
import PackageContactController from '../pages/package-contact/PackageContactController'
import { getOrderStatusCache, order_key } from '../utils/order_cache'
import CustomFooter from '../components/CustomFooter'
import LandingPageV2Controller from '../pages/landing-page/LandingPageV2Controller'

function PrecheckRoute(props) {
    const { component, label, ...rest } = props;
    const session = getData();
    const orderStatusInfo = getOrderStatusCache(order_key.order_status) ? JSON.parse(getOrderStatusCache(order_key.order_status)) : null;
    console.log("orderStatusInfo PrecheckRoute===", orderStatusInfo);
    let Component = component;
    let location = rest.location.pathname;
    var redirectPath = null;
    // console.log("session:",session);
    if (!session) {
        clearSession();
        location = paths.login
        Component = document._portalConfig.use1Map ? LandingPageV2Controller : LandingPageController;
    }else{
        // if(location !== paths.package_contact)
        // {
        //     if(orderStatusInfo && orderStatusInfo.status === 'VUMATEL_ORDER_EXCEPTION') {
        //         location = paths.package_contact
        //         Component = PackageContactController
        //     }
        // }
    }
    if (location !== paths.home) {
        redirectPath = getRedirectPath(location);
    }
    console.log("location:",location);
    console.log("redirectPath:",redirectPath);
    return (
        <Route
            {...rest}
            render={routeProps =>
                !redirectPath ? 
                (<ComponentRouter location={location} component={<Component {...routeProps} rootProps={props.rootProps} />} />) 
                : (<Redirect
                        to={{
                            pathname: redirectPath,
                            state: { from: location }
                        }}
                    />
                    )
            }
        />
    );
}

function ComponentRouter(props) {
    if(props.location === paths.login){
        return (
            <>
                {props.component}
                {/* {props.location === paths.package_contact && <CustomFooter />} */}
            </>
        );
    } else { 
        return (
            <CustomMain>
                {props.component}
            </CustomMain>
        )
    }
}

function getRedirectPath(location) {
    const session = getData();
    const acl = routeACL[location];
    if (!acl)
        return null;
    if (!getData()) { // no session
        console.log('XXXXX: no Session')
        if (isSessionRequired(acl))
            return paths.home;
        else
            return null;
    }
    if (!session)
        return paths.home;
    if (isSessionRequired(acl) === false)
        return null;
}

function isSessionRequired(acl) {
    return acl === SCOPE._IN_SESSION;
}

export default PrecheckRoute;


